export const DEFAULT_PLACEHOLDER_IMAGE = "/resource/placeholder.png"

/**
 * Rewrites backend upload URLs to same-origin `/uploads/...` paths so Next.js
 * can proxy them via rewrites and the image optimizer can fetch them reliably.
 */
export function toProxyUploadUrl(source: string): string {
  if (!source) return source
  if (source.startsWith("/uploads/")) return source

  if (source.startsWith("http://") || source.startsWith("https://")) {
    try {
      const url = new URL(source)
      if (url.pathname.startsWith("/uploads/")) {
        return `${url.pathname}${url.search}`
      }
    } catch {
      return source
    }
    return source
  }

  if (source.startsWith("uploads/")) {
    return `/${source}`
  }

  return source
}
